export * from "./resource-asset-display-config.view";